import { render, staticRenderFns } from "./serverFault.vue?vue&type=template&id=dbae6a5a&scoped=true"
import script from "./serverFault.vue?vue&type=script&lang=js"
export * from "./serverFault.vue?vue&type=script&lang=js"
import style0 from "./serverFault.vue?vue&type=style&index=0&id=dbae6a5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbae6a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbae6a5a')) {
      api.createRecord('dbae6a5a', component.options)
    } else {
      api.reload('dbae6a5a', component.options)
    }
    module.hot.accept("./serverFault.vue?vue&type=template&id=dbae6a5a&scoped=true", function () {
      api.rerender('dbae6a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/dcopsTicket/serverFault.vue"
export default component.exports